import React from "react";
import { data } from "../constants/data";
import { FaBookReader } from "react-icons/fa";

const Card = (props) => {
  return (
    <>
      <div className="w-4xl mt-3 flex gap-4 items-center border border-gray-200 dark:border-gray-800 rounded p-4 hover:shadow hover:border hover:border-gray-300 dark:hover:border dark:hover:border-sky-500">
        <div className="h-16 w-20 ml-2 mr-4">
          <img className="object-scale-down h-20 w-20 mb-10" src={props.img} />
        </div>
        <div>
          <h4 className="text-lg font-bold tracking-tight text-gray-900 dark:text-gray-100">
            {props.name}
          </h4>
          <p className="leading-5 text-gray-700 dark:text-gray-300">
            {props.program}
          </p>
          <div className="pt-2 flex  md:flex-row md:space-x-9 text-sm">
            <p className="flex leading-5 text-gray-700 dark:text-gray-500 dark:bg-transparent rounded-sm italic bg-gray-50 ">
              {props.duration}
            </p>
            <p className="flex flex leading-5 text-gray-700 dark:text-gray-500 dark:bg-transparent rounded-sm italic bg-gray-50 ">
              {props.score}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const Education = () => {
  return (
    <>
      {data.education.map((dt) => {
        return (
          <Card
            name={dt.name}
            program={dt.program}
            duration={dt.duration}
            score={dt.score}
            img={dt.img}
          />
        );
      })}
    </>
  );
};

export default Education;
